import Vue from "vue";
// import store from "@/store"
import draggable from "vuedraggable";
import Properties from "@/components/form_elements_sentences/properties/Properties.vue";

import FormTitle from "@/components/form_elements_sentences/forms/FormTitle";
import FormExample from "@/components/form_elements_sentences/forms/FormExample";
import FormSentence from "@/components/form_elements_sentences/forms/FormSentence";

import FormElementIllustration from "@/components/form_elements_sentences/formElements/FormElementIllustration";
import FormElementStructure from "@/components/form_elements_sentences/formElements/FormElementStructure";
import FormElementChallenge from "@/components/form_elements_sentences/formElements/FormElementChallenge";
import vm from "@/main";

export const FormBuilder = new Vue({
    components: {
        draggable,
        Properties,
        FormTitle,
        FormExample,
        FormSentence,
        FormElementIllustration,
        FormElementStructure,
        FormElementChallenge,
    },
    data() {
        return {
            fields: [{
                    fieldType: "FormTitle",
                    type: "Form",
                    text: "タイトル・説明",
                    key: "FormTitle",
                    id: "",
                    data: [],
                    cols: 12,
                },
                {
                    fieldType: "FormExample",
                    type: "Form",
                    text: "例文",
                    key: "FormExample",
                    id: "",
                    data: [],
                    cols: 12,
                },
                // {
                //     fieldType: "FormSentence",
                //     type: "Form",
                //     text: "チャレンジ",
                //     key: "FormSentence",
                //     id: "",
                //     data: [],
                //     cols: 12,
                // },
                {
                    fieldType: "FormElementIllustration",
                    type: "image",
                    text: "挿絵データ",
                    key: "Illustration",
                    disabled: true,
                    require: false,
                    id: "",
                    file: null,
                    cols: 12,
                },
                {
                    fieldType: "FormElementStructure",
                    type: "button",
                    text: "文構造",
                    key: "Structure",
                    disabled: true,
                    require: false,
                    id: "",
                    isType: "BOX",
                    alignItems: "center",
                    value: {},
                    width: 2,
                    color: "#69BE5B",
                },
                {
                    fieldType: "FormElementChallenge",
                    type: "text",
                    text: "チャレンジ文",
                    key: "Challenge",
                    disabled: true,
                    require: false,
                    id: "",
                    value: {},
                    cols: 12,
                },
            ],
        };
    },
    methods: {
        deleteElement(index, form) {
            this.$delete(form, index);
            vm.$store.tabExpression = "forms";
            vm.$store.activeFieldExpression = {};
        },

        cloneElement(index, field, form, fieldsDefaultID) {
            var cloned = this._.cloneDeep(field); // clone deep lodash
            cloned.id = `${fieldsDefaultID}`;
            form.splice(index + 1, 0, cloned);
            this.editElementProperties(cloned);
        },
        editElementProperties(field) {
            vm.$store.activeFieldExpression = field;
        },
    },
});